'use client';

import { AuthorSkeleton } from '@/app/[locale]/(entity)/components/interaction/loading/AuthorSkeleton';
import { useProjectTabs } from '@/app/[locale]/(entity)/hooks/useProjectTabs';
import { TabsFilterValue } from '@/app/[locale]/(entity)/types/project/tabs';

export const InteractionDetailSkeleton = () => {
  const { activeTabFilter } = useProjectTabs();

  const isAnnouncement = activeTabFilter === TabsFilterValue.NEWS;

  return (
    <article
      className={isAnnouncement ? 'announcement' : 'interaction-detail'}
      style={{ minHeight: '100vh' }}
      data-testid="interaction-detail-skeleton"
    >
      {isAnnouncement
        ? (
            <>
              <h2 className="vp-title-l announcement-card__title">
                <div
                  className="vtmn-skeleton vtmn-skeleton_line"
                  style={{
                    width: '100%',
                    height: '44px',
                  }}
                />
              </h2>
              <div className="announcement-card__counters-display">
                <div
                  className="vtmn-skeleton vtmn-skeleton_line"
                  style={{
                    width: '48px',
                    height: '24px',
                  }}
                />
              </div>
              <div className="vp-body-m announcement-card__description">
                {[...Array.from({ length: 10 }).keys()].map(key => (
                  <p
                    key={key}
                    className="vtmn-skeleton vtmn-skeleton_line"
                    style={{
                      height: '24px',
                    }}
                  />
                ))}
              </div>
            </>
          )
        : (
            <div className="interaction centered-content">
              <div className="interaction-header">
                <div
                  className="vtmn-skeleton vtmn-skeleton_line"
                  style={{ width: '144px', height: '32px' }}
                />
                <h2 className="vp-title-l">
                  <div
                    className="vtmn-skeleton vtmn-skeleton_line"
                    style={{ width: '100%', height: '32px' }}
                  />
                </h2>
              </div>
              <section
                className="interaction-content"
                data-testid="interaction-content"
              >
                <div className="interaction-summary">
                  <div className="interaction-summary__options interaction-summary__options--white-background">
                    <div className="interaction-option">
                      <span
                        className="vtmn-skeleton vtmn-skeleton_avatar"
                        style={{ width: '40px', height: '40px' }}
                      />
                      <div
                        className="vtmn-skeleton vtmn-skeleton_line"
                        style={{ width: '100%', height: '24px' }}
                      />
                    </div>
                    <div className="interaction-option">
                      <span
                        className="vtmn-skeleton vtmn-skeleton_avatar"
                        style={{ width: '40px', height: '40px' }}
                      />
                      <div
                        className="vtmn-skeleton vtmn-skeleton_line"
                        style={{ width: '100%', height: '24px' }}
                      />
                    </div>
                  </div>
                  <div className="interaction-aside__author">
                    <AuthorSkeleton />
                  </div>
                </div>
                <div className="interaction-aside">
                  <div className="interaction-aside__shortcuts">
                    <header>
                      <div
                        className="vtmn-skeleton vtmn-skeleton_line"
                        style={{ width: '100%', height: '24px' }}
                      />
                    </header>
                  </div>
                </div>
              </section>
            </div>
          )}
    </article>
  );
};
